type ContactCardProps = {
  heading: string;
  description: string;
  email: string;
};

export function ContactCard({ heading, description, email }: ContactCardProps) {
  return (
    <section className="contact-card" aria-labelledby="contact-title">
      <h2 id="contact-title">{heading}</h2>
      <p>{description}</p>
      <a className="text-link" href={`mailto:${email}`}>
        {email}
      </a>
    </section>
  );
}
